<template>
	<div class="login">
		<b-container class="bv-example-row login_bg">
			<!--<b-row class="justify-content-md-center mt-xl"><b-alert show variant="danger" v-if="error_msg.length>0">{{error_msg}}</b-alert></b-row>
			 <b-row class="justify-content-md-center mb-3">
				<h3 class="text-white col-md-6 text-center">{{$session.get('app_name')}}</h3>
			</b-row> -->
			<b-row class="justify-content-md-center mt-xl"><b-alert show variant="danger" v-if="error_msg.length>0">{{error_msg}}</b-alert></b-row>
			<b-row class="justify-content-md-center " >
				<b-card header-tag="header" footer-tag="footer" class="mb-0 pl-0 pr-0 col-md-5 loginBox">
					<template v-slot:header>
						<h2> Bharatpur Nagar Nigam</h2>
						<b-img src="../assets/logo.png" fluid alt="logo" class="logoRound"></b-img>
						<!-- <h5 class="mb-2 mt-2">Street Light Department {{$session.get('app_name')}} </h5> -->
						<h6 class="mb-2">Central Control & Monitoring System (CCMS) </h6>
						

					</template>
					<b-card-text>
						<form v-on:keyup.enter="login()">
							<p>
								<b-form-input v-model="email" type="email" placeholder="Username or Email address"></b-form-input>
							</p>
							<p>
								<b-form-input v-model="password" type="password" placeholder="Password"></b-form-input>
							</p>
						</form>
					</b-card-text>
					<p class="p-0 text-center">
						<b-button href="#" variant="warning" class=" p-1 mt-3 mb-3" size="lg" @click="login()" style="color:#fff;width: 80%;" >Login</b-button>
					</p>
					
				</b-card>
			</b-row>
			<b-row class="justify-content-md-center">
				<p class="text-white col-md-4 text-center">APP VER: 2.2</p>
			</b-row>
		</b-container>
	</div>
</template>
<script>
export default {
	name: 'Login',
	components: {
	},
	beforeCreate: function() {
        document.body.className = 'login';
    },
	data() {
		var self = this;
		return{
			email: '',
			password: '',
			error_msg: '',
			url: self.$session.get('apiurl')+'bareillyapi/login'
		};
	},
	methods: {
		login(){
			var self = this;
			self.axios.post(self.url, {
				email: self.email,
				pass: self.password
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.error_msg = '';
					
					self.$session.set('access_key', response.data.result.access_key);

					var user_info = response.data.result;
					user_info.options = JSON.parse(response.data.result.options);

					user_info.permissions = JSON.parse(response.data.result.permissions);

					//user_info.options = JSON.parse(user_info.options);
					//console.log(JSON.stringify(user_info));

					/*self.$root.showMessage('Server Error', 'Reload again', 'ok', function(){
						alert('reload');
					});*/

					self.$session.set('user_info', user_info);

					self.$root.access_key = response.data.result.access_key;

					if(user_info.permissions.dashboard_link){
						self.$router.push(user_info.permissions.dashboard_link);
					}else{
						self.$router.push('/dashboard');
					}
				}else{
					self.error_msg = response.data.message;
				}
			})
			.catch(function (error) {
				alert(error);
			});
			//alert('login '+self.email+" "+self.password);
		}
	}
}
</script>

<style>
html{
	min-height: 100%;
}
body{
	background-image: url(../assets/home-banner.png) !important;
	background-repeat: no-repeat;
	background-size: cover;
	background-position: center center;
}
.mt-xl{
	margin-top: 100px;
}
.btn-black{
	background-color: #000;
	color: #FFF;
	padding: 6px 25px;
}

.loginBox{
	border-radius: 20px;
    opacity: 1;
    background: transparent;
    backdrop-filter: blur(45px);
    -webkit-backdrop-filter: blur(45px);
    height: auto;

}

.loginBox .card-header{
	
    text-align: center;
    color: #FFF;
    padding: 2px;
    margin: 24px;
    border: 0px;
}
.loginBox .form-control{
	background-color: #FFFFFF38 !important;
	color:#fff;
	font-size: 20px;
	
}

.btn-warning {
    color: #212529;
    background-color: #FF9F43;
    border-color: #FF9F43;
}
.logoRound{
	/* background-color: #fff;
    border: 1px solid #fff;
    border-radius: 50%; */
	width: 30%;
}
</style>